import { render, staticRenderFns } from "./Title_JobStatusList.vue?vue&type=template&id=624369b4&scoped=true&"
import script from "./Title_JobStatusList.vue?vue&type=script&lang=js&"
export * from "./Title_JobStatusList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624369b4",
  null
  
)

export default component.exports